export default __webpack_public_path__ + "static/team-member-4-111468194a258c01a449d85c2d0e7b67.png";